import FormattedPropertyV2 from 'customer-data-properties/formatted/FormattedPropertyV2';
import { COMPANY_TYPE_ID, CONTACT_TYPE_ID, DEAL_TYPE_ID, TICKET_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import RecordLink from 'crm-links/record/RecordLink';
import ArtificialIntelligenceAssociationIcon from '../../../chicklets/associations/ArtificialIntelligenceAssociationIcon';
import { getPropertyValueFromProperties } from '../../../helpers/propertiesHelpers';
import { useCallback } from 'react';
import CrmLogger from 'customer-data-tracking/loggers/CrmLogger';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const getObjectTypeTestIdentifier = objectTypeId => {
  switch (objectTypeId) {
    case COMPANY_TYPE_ID:
      return 'company';
    case CONTACT_TYPE_ID:
      return 'contact';
    case DEAL_TYPE_ID:
      return 'deal';
    case TICKET_TYPE_ID:
      return 'ticket';
    default:
      return 'crmobject';
  }
};
const DefaultChickletPrimaryDisplayLabel = ({
  toObjectTypeId,
  toObjectId,
  primaryDisplayProperty,
  canView,
  properties,
  isAiAssociation
}) => {
  const handleTrackClick = useCallback(({
    objectId,
    objectTypeId
  }) => {
    CrmLogger.log('sidebar-interaction', {
      action: 'Clicked on the Primary Display Label',
      objectId: objectId.toString(),
      objectTypeId
    });
  }, []);
  if (!primaryDisplayProperty || !primaryDisplayProperty.definition) {
    return null;
  }
  const testIdentifier = getObjectTypeTestIdentifier(toObjectTypeId);
  const {
    definition,
    value
  } = primaryDisplayProperty;
  const label = /*#__PURE__*/_jsxs(Flex, {
    as: "span",
    alignItems: "center",
    children: [/*#__PURE__*/_jsx(FormattedPropertyV2, {
      objectTypeId: toObjectTypeId,
      objectId: toObjectId.toString(),
      value: value,
      getDraftValue: () => undefined,
      getSavedValue: propertyName => getPropertyValueFromProperties(properties, propertyName),
      "data-selenium-test": `property-input-${definition.name}`,
      "data-test-id": `property-input-${definition.name}`
      // @ts-expect-error Known property issue as they have not updated the type definitions
      // https://hubspot.slack.com/archives/C025K57CMMG/p1696524684019289?thread_ts=1696349045.450059&cid=C025K57CMMG
      ,
      property: definition
    }), isAiAssociation && /*#__PURE__*/_jsx(ArtificialIntelligenceAssociationIcon, {})]
  });
  if (!canView) {
    return /*#__PURE__*/_jsx("div", {
      "data-selenium-test": `${testIdentifier}-chicklet-title`,
      "data-test-id": `${testIdentifier}-chicklet-title`,
      children: /*#__PURE__*/_jsx("strong", {
        "data-selenium-test": `${testIdentifier}-chicklet-title-read-only`,
        "data-test-id": `${testIdentifier}-chicklet-title-read-only`,
        "data-unit-test": `${testIdentifier}-chicklet-title-read-only`,
        children: label
      })
    });
  }
  return /*#__PURE__*/_jsx("div", {
    "data-selenium-test": `${testIdentifier}-chicklet-title`,
    "data-test-id": `${testIdentifier}-chicklet-title`,
    children: /*#__PURE__*/_jsx(RecordLink, {
      includeEschref: true,
      objectId: toObjectId,
      objectTypeId: toObjectTypeId,
      onTrackClick: handleTrackClick,
      children: /*#__PURE__*/_jsx("span", {
        "data-selenium-test": `${testIdentifier}-chicklet-title-link`,
        "data-test-id": `${testIdentifier}-chicklet-title-link`,
        children: label
      })
    })
  });
};
export default DefaultChickletPrimaryDisplayLabel;